import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import defaultStyles from './badge.scss';

export interface Props {
    children: React.ReactChild | null;
    styles: typeof defaultStyles;
    src?: string;
    alt?: string | null;
    uppercase?: boolean;
}


class Badge extends React.PureComponent<Props> {
    render() {
        const { styles, children, src, alt, uppercase } = this.props;

        return (
            <div className={classnames(styles.badge, { [styles.uppercase]: uppercase })}>
                {src ? <SVGIcon style={{image: styles.image}}  src={src} alt={alt || ''} /> : null}
                {children}
            </div>
        );
    }
}

export default Styled(defaultStyles)(Badge);
